export default __webpack_public_path__ + "static/media/xbox-controller.bcbb7f6b.png";